export const LOADING_OPERATION = 'LOADING_OPERATION';
export const FETCH_COMM_DATA = 'FETCH_COMM_DATA';
export const FETCH_COMM_DETAIL_DATA = 'FETCH_COMM_DETAIL_DATA';
export const FETCH_UNREAD_COMM = 'FETCH_UNREAD_COMM';
